import { gql } from '@apollo/client';

export const PULL_PRODUCT_RECOMMENDATIONS = gql`
    mutation PULL_PRODUCT_RECOMMENDATIONS(
        $productID: String
        $sessionID: String
        $customerID: String
        $selectedQuestionnaire: [SelectedQuestionnaireRQ]
    ) {
        pullProductRecommendations(
            request: {
                productGroup: $productID
                sessionId: $sessionID
                customerId: $customerID
                selectedQuestionnaire: $selectedQuestionnaire
            }
        ) {
            recommendedProducts {
                name
                productDesc
                sellingPoints
                applyUrl
                learnMore
                imageId
            }
        }
    }
`;
